import type { Column } from '../../../model/columns/types.tsx';

/**
 * @deprecated Use `LOAD_CONFIG_DATA_MODEL_SUCCESS`. Best practices "actions as events" - https://redux.js.org/style-guide/#model-actions-as-events-not-setters
 */
export const SET_COLUMNS = 'state.actions.columns.SET_COLUMNS' as const;

/**
 * @deprecated Use `LOAD_CONFIG_DATA_MODEL_SUCCESS`. Best practices "actions as events" - https://redux.js.org/style-guide/#model-actions-as-events-not-setters
 */
export type SetColumnsAction = {
	type: typeof SET_COLUMNS;
	payload: {
		columns: {
			[key: string]: Column;
		};
	};
};

/**
 * @deprecated Use `LOAD_CONFIG_DATA_MODEL_SUCCESS`. Best practices "actions as events" - https://redux.js.org/style-guide/#model-actions-as-events-not-setters
 */
export const setColumns = (columns: { [key: string]: Column }): SetColumnsAction => ({
	type: SET_COLUMNS,
	payload: {
		columns,
	},
});

export type Action = SetColumnsAction;
